import { allergiesAPI } from '../api/allergy';
import { objectToFormData } from '../utils/functions';
import { actionWrapper } from './actionWrapper';

export const SET_ALLERGIES = 'SET_ALLERGIES';
export const DELETE_ALLERGY = 'DELETE_ALLERGY';

export const getAllergies = () => actionWrapper(async () => {
  const allergiesData = await allergiesAPI.getAllergies();

  return {
    type: SET_ALLERGIES,
    payload: allergiesData,
  };
});

export const addAllergy = (allergyData) => actionWrapper(async (dispatch) => {
  await allergiesAPI.addAllergy(allergyData);
  dispatch(getAllergies());
});

export const updateAllergy = (allergyData) => actionWrapper(async (dispatch) => {
  await allergiesAPI.updateAllergy(allergyData);
  dispatch(getAllergies());
});

export const deleteAllergy = (id) => actionWrapper(async () => {
  await allergiesAPI.deleteAllergy(id);

  return {
    type: DELETE_ALLERGY,
    payload: id,
  };
});

export const importAllergies = (importData, callback) => actionWrapper(async () =>{
  const formData = objectToFormData(importData);
  await allergiesAPI.importAllergies(formData);
  callback?.();
});

export const addAllergyIngredient = (ingredientData, callback) => actionWrapper(async (dispatch) =>{
  await allergiesAPI.addAllergyIngredient(ingredientData);
  dispatch(getAllergies());
  callback?.();
});

export const deleteAllergyIngredient = (ingredientData, callback) => actionWrapper(async (dispatch) =>{
  await allergiesAPI.deleteAllergyIngredient(ingredientData);
  dispatch(getAllergies());
  callback?.();
});